"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ForgotPasswordLink = exports.ErrorMessage = exports.LoginFormWrapper = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _templateObject = _taggedTemplateLiteral(["\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  button {\n    border: 1px solid #333;\n    margin-left: 7px;\n  }\n"], ["\n  padding: 10px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  button {\n    border: 1px solid #333;\n    margin-left: 7px;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  color: #ed4337;\n"], ["\n  color: #ed4337;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 12px;\n  margin-left: 10px;\n  span {\n    text-decoration: underline;\n\n    cursor: pointer;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"], ["\n  display: inline-block;\n  font-size: 12px;\n  margin-left: 10px;\n  span {\n    text-decoration: underline;\n\n    cursor: pointer;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  label {\n    margin-right: 10px;\n    text-align: left;\n  }\n  input {\n    width: 100%;\n    max-width: 350px;\n    margin-bottom: 12px;\n    border: 1px solid #ccc;\n    padding: 6px 10px 6px 8px;\n    border-radius: 0.25em;\n  }\n"], ["\n  label {\n    margin-right: 10px;\n    text-align: left;\n  }\n  input {\n    width: 100%;\n    max-width: 350px;\n    margin-bottom: 12px;\n    border: 1px solid #ccc;\n    padding: 6px 10px 6px 8px;\n    border-radius: 0.25em;\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Form = require("react-bootstrap/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Alert = require("react-bootstrap/Alert");

var _Alert2 = _interopRequireDefault(_Alert);

var _reactAxios = require("@dreamchimney/react-axios");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getUser = require("./api/getUser");

var _main = require("./utils/main");

var _Spinner = require("react-bootstrap/Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // import { useUser } from "~/Context/userContext";


var LoginFormWrapper = exports.LoginFormWrapper = _styledComponents2.default.section(_templateObject);

var useSignUpForm = function useSignUpForm(initialValues, callback) {
  var _useState = (0, _react.useState)(initialValues),
      _useState2 = _slicedToArray(_useState, 2),
      inputs = _useState2[0],
      setInputs = _useState2[1];

  var handleSubmit = function handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    callback();
  };

  var handleInputChange = function handleInputChange(event) {
    event.persist();
    setInputs(function (inputs) {
      return _extends({}, inputs, _defineProperty({}, event.target.name, event.target.value));
    });
  };

  return {
    handleSubmit: handleSubmit,
    handleInputChange: handleInputChange,
    inputs: inputs
  };
};

var ErrorMessage = exports.ErrorMessage = _styledComponents2.default.section(_templateObject2);

var ForgotPasswordLink = exports.ForgotPasswordLink = _styledComponents2.default.section(_templateObject3);

var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject4);

var Login = function Login(_ref) {
  var _ref$opened = _ref.opened,
      opened = _ref$opened === undefined ? false : _ref$opened,
      onSuccess = _ref.onSuccess; //   const { state: userState, dispatch } = useUser();

  var _useState3 = (0, _react.useState)(opened),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasError = _useState6[0],
      setHasError = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      passwordResetSuccess = _useState10[0],
      setPasswordResetSuccess = _useState10[1];

  var inputElPassword = (0, _react.useRef)(null);

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showPassword = _useState12[0],
      setShowPassword = _useState12[1];

  (0, _react.useEffect)(function () {
    setOpen(opened);
  }, [opened]);

  var loginCb = function loginCb() {
    setLoading(true);
    (0, _getUser.userLogin)(_reactAxios.axiosAuth, _getUser.urlLogin, inputs).then(function (_ref2) {
      var _ref2$data = _ref2.data,
          success = _ref2$data.success,
          isChim = _ref2$data.isChim,
          jwt = _ref2$data.jwt,
          _ref2$data$error_type = _ref2$data.error_type,
          error_type = _ref2$data$error_type === undefined ? "" : _ref2$data$error_type,
          _ref2$data$user = _ref2$data.user,
          user = _ref2$data$user === undefined ? {} : _ref2$data$user;

      if (success) {
        setHasError(false);
        setLoading(false);
        inputs.loginemail = "";
        inputs.password = "";
        localStorage.setItem(_main.LOCAL_STORE_JWT, jwt); // @TODO any post login action - context related
        //   if (isChim === false) {
        //     console.log("user_login user:", user);
        //     dispatch({ type: "user_login", payload: { user } });
        //   } else {
        //     console.log("chim login user:", user);
        //     dispatch({ type: "login", payload: { user } });
        //   }

        var loginType = isChim === false ? "user_login" : "login";
        var successPayload = {
          dispatch: {
            type: loginType,
            payload: {
              user: user,
              jwt: jwt
            }
          }
        }; // @TODO any post login action - saving favorite. etc

        onSuccess(successPayload);
        window.scrollTo(0, 0);
      } else {
        console.log("error_type:", error_type);

        if (error_type === "password_missing") {
          setShowPassword(true);
          inputElPassword.current.focus();
        } else {
          setHasError(true);
        }

        setLoading(false);
      }
    }).catch(function (e) {
      console.log("🚀 ~ file: Login.js ~ line 115 ~ loginCb ~ e", e);
      var _e$response = e.response;
      _e$response = _e$response === undefined ? {} : _e$response;
      var data = _e$response.data;
      console.log("login error response.data", data);

      if (data && data.error_type === "password_missing") {
        setShowPassword(true);
        inputElPassword.current.focus();
      } else {
        setHasError(true);
      }

      setLoading(false);
    });
  };

  var forgotPassword = function forgotPassword() {
    var payload = {
      email: inputs.loginemail
    };
    (0, _getUser.userPasswordForgot)(_reactAxios.axiosAuth, payload).then(function (_ref3) {
      var data = _ref3.data;
      console.log("data:", data);
      setHasError(false);
      setPasswordResetSuccess(true);
    }).catch(function (e) {
      setHasError(true);
    });
  };

  var _useSignUpForm = useSignUpForm({
    loginemail: ""
  }, loginCb),
      inputs = _useSignUpForm.inputs,
      handleInputChange = _useSignUpForm.handleInputChange,
      handleSubmit = _useSignUpForm.handleSubmit; //   if (!open || userState.loggedin) {


  if (!open) {
    return null;
  }

  return _react2.default.createElement(LoginFormWrapper, null, _react2.default.createElement(_Form2.default, {
    className: "login-form",
    noValidate: true,
    onSubmit: handleSubmit
  }, _react2.default.createElement(Wrapper, null, _react2.default.createElement("div", null, loading && _react2.default.createElement(_Spinner2.default, {
    animation: "border",
    variant: "secondary"
  }), hasError && _react2.default.createElement(ErrorMessage, null, "There was an error with login, please try again."), passwordResetSuccess && _react2.default.createElement(_Alert2.default, {
    variant: "success"
  }, "Check your email for a link to reset your password.")), _react2.default.createElement("div", null, _react2.default.createElement("label", null, "Login Email Address:"), _react2.default.createElement("input", {
    type: "loginemail",
    name: "loginemail",
    onChange: handleInputChange,
    value: inputs.loginemail,
    required: true
  })), showPassword && _react2.default.createElement("div", null, _react2.default.createElement("label", null, "Password:", _react2.default.createElement(ForgotPasswordLink, {
    onClick: forgotPassword
  }, "(", _react2.default.createElement("span", null, "Forgot Password"), "?)")), _react2.default.createElement("input", {
    type: "password",
    name: "password",
    ref: inputElPassword,
    onChange: handleInputChange,
    value: inputs.password,
    required: true
  })), _react2.default.createElement(_Button2.default, {
    style: {
      padding: "5px 20px",
      margin: 0
    },
    variant: "secondary",
    size: "sm",
    type: "submit"
  }, "Next"))));
};

exports.default = Login;